/**
 * 增加输入框的失焦处理逻辑
 * @param key 用来标识对应的feature
 * @param beforeChangeFn 初始化之前执行的方法
 * @param afterBlurFn 失焦结束后执行的方法
 * @returns
 */
export function handleInputBlurInitAndReset(key?: string, beforeChangeFnName?: string, afterBlurFnName?: string) {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;

        descriptor.value = function (...args: any[]) {
            this.getDrawerInputManager()?.updateTempMethod({
                className: this,
                method: originalMethod,
                args,
            });
            const inputParams = this.getInputParams();
            if (inputParams) {
                key = inputParams.key ?? key;
                beforeChangeFnName = inputParams.beforeChangeFnName ?? beforeChangeFnName;
                afterBlurFnName = inputParams.afterBlurFnName ?? afterBlurFnName;
            }

            beforeChangeFnName && this[beforeChangeFnName]?.();
            this.getDrawerInputManager()?.initBeforeChangeOnBlur(key);

            originalMethod.apply(this, args);

            // 失焦后重置
            const hasExecuted = this.getDrawerInputManager()?.resetAfterChangeOnBlur(key);
            if (hasExecuted) {
                afterBlurFnName && this[afterBlurFnName]?.();
            }
        };

        return descriptor;
    };
}

export interface IInputParams {
    key: string,
    beforeChangeFnName?: string,
    afterBlurFnName?: string
}
